// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.annuaire-page {
  width: 100%;
  padding: 0;
}

.annuaire-page h1 {
  margin-bottom: 3rem;
}

.annuaire-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 2rem 0;
}

.header-actions {
  display: flex;
  gap: 1rem;
}

.entreprise-info {
  display: flex;
  flex-direction: column;
}

.avatar-placeholder {
  width: 4rem;
  height: 4rem;
  border-radius: 50%;
  background-color: #e5e7eb;
  overflow: hidden;
}

.action-button {
  background: none;
  border: none;
  cursor: pointer;
  font-size: 1.8rem;
  color: #2c3948;
}

.action-button:hover {
  color: #f97316;
}

.entreprise-cell {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.entreprise-logo {
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  border-radius: 4px;
}

.entreprise-logo img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

.entreprise-nom {
  font-weight: 500;
}

.information-cell {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.contact-name {
  font-weight: 700;
}

/* Remplacer le style existant des documents-cell */
.documents-cell {
  position: relative;
  /* max-width: 60px; */
}

/* Style pour le bouton qui affichera les documents */
.documents-toggle {
  display: inline-flex;
  align-items: center;
  background-color: transparent;
  border: none;
  padding: 0.25rem;
  font-size: 0.8rem;
  cursor: pointer;
  color: #2c3948;
  transition: color 0.2s;
  white-space: nowrap;
}

.documents-toggle:hover {
  color: #f97316;
}

.documents-toggle svg {
  width: 30px;
  height: 30px;
}

/* Style pour le bouton qui n'affiche que l'icône */
.documents-toggle.documents-icon-counter {
  display: flex;
  align-items: center;
  justify-content: center;
  /* background: transparent; */
  border: none;
  padding: 4px;
  cursor: pointer;
  transition: transform 0.2s ease;
}

.documents-toggle.documents-icon-counter:hover {
  /* transform: scale(1.2); */
}

.document-outline-icon {
  width: 24px;
  height: 24px;
}

.documents-count {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  /* border-radius: 50%; */
  width: 18px;
  height: 18px;
  font-size: 1.5rem;
  margin-left: 0.25rem;
}

/* Popup pour afficher les documents */
.documents-popup {
  position: absolute;
  top: 0%;
  left: -279px;
  margin-bottom: 4px;
  background-color: white;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  padding: 12px;
  z-index: 100;
  min-width: 280px;
  max-width: 400px;
  opacity: 0;
  visibility: hidden;
  transform: translateY(8px);
  transition:
    opacity 0.2s,
    visibility 0.2s,
    transform 0.2s;
}

.documents-popup-list {
  display: flex;
  gap: 0.5rem;
  flex-direction: column;
}

/* Pour les lignes en bas du tableau, afficher le popup au-dessus */
.tableau-de-bord-table tr:nth-last-child(-n + 3) .documents-popup {
  bottom: auto;
  top: 100%;
  margin-top: 4px;
  margin-bottom: 0;
  transform: translateY(-8px);
}

.documents-cell:hover .documents-popup {
  opacity: 1;
  visibility: visible;
  transform: translateY(0);
}

/* .documents-list {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0.75rem;
} */

.annuaire-page .document-item {
  display: flex;
  align-items: center;
  gap: 8px;
  background-color: rgba(215, 217, 217, 0.2);
  text-decoration: none;
  font-size: 0.85rem;
  padding: 6px 8px;
  border-radius: 4px;
  transition: all 0.2s ease; /* Transition douce pour tous les changements */
}

.annuaire-page .document-item:hover {
  background-color: rgba(194, 194, 194, 0.46); /* Couleur de fond au survol */
}

.annuaire-page .document-item:active {
  background-color: #e5e7eb; /* Couleur légèrement plus foncée lors du clic */
  transform: translateY(1px); /* Léger effet d'enfoncement */
}

.annuaire-page .document-item .document-icon {
  width: 16px;
  height: 16px;
  flex-shrink: 0;
  transition: color 0.2s; /* Transition pour la couleur de l'icône */
}

.annuaire-page .document-item:hover .document-icon {
  color: #f97316; /* Même couleur que le texte au survol */
}

.annuaire-page .document-item svg {
  width: 16px;
  flex-shrink: 0;
}

.document-link {
  color: #2c3948;
  text-decoration: none;
  font-size: 0.875rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.document-link:hover {
  text-decoration: underline;
  color: #f97316;
}

/* Animation pour l'apparition du popup */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-5px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.documents-popup {
  animation: fadeIn 0.2s ease-out;
}

/* Styles pour l'en-tête du tableau */
.tableau-de-bord-header {
  background-color: #f3f4f6;
  font-weight: 600;
}

/* Définir des largeurs fixes pour les colonnes du tableau */
.categorie-cell {
  max-width: 150px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.departement-cell {
  max-width: 120px;
  white-space: nowrap;
}

.rang-cell {
  max-width: 60px;
  text-align: center;
}

.entreprise-cell {
  max-width: 200px;
}

.information-cell {
  max-width: 180px;
}

/* Styles pour les filtres dropdown */
.annuaire-filters {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  margin: 3rem 0 1.5rem;
  padding: 1rem 0;
  border-radius: 0.5rem;
}

.filter-dropdown {
  display: flex;
  flex-direction: column;
  min-width: 200px;
  flex: 1 1;
}

.filter-dropdown label {
  margin-bottom: 0.5rem;
  /* font-size: 0.875rem; */
  font-weight: 500;
  color: #606060;
}

/* .filter-dropdown select {
  padding: 0.5rem 1rem;
  border: 1px solid #ddd;
  border-radius: 0.25rem;
  background-color: white;
  font-size: 0.875rem;
  height: 40px;
  transition: border-color 0.2s;
} */

.filter-dropdown select:focus {
  border-color: #f97316;
  outline: none;
}

/* Style responsive */
@media (max-width: 768px) {
  .annuaire-filters {
    flex-direction: column;
  }

  .filter-dropdown {
    width: 100%;
  }
}

.acheteur-localisation-cell {
  display: flex;
  align-items: center;
}

.code-postal {
  font-size: 14px;
}

.country-flag {
  font-size: 16px;
}

.entite-logo {
  width: 40px; /* largeur du logo */
  height: 40px; /* hauteur du logo */
  object-fit: contain; /* pour que l’image garde ses proportions */
  margin-left: 8px; /* espacement par rapport au nom de l’entreprise */
  border-radius: 4px; /* coins légèrement arrondis */
  vertical-align: middle; /* alignement avec le texte */
}

.entite-logo-spinner {
  width: 1em !important;
  height: 1em !important;
  border: 4px solid #f3f3f3; /* gris clair */
  border-top: 4px solid #3498db; /* bleu */
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-left: 8px;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.modal-overlay-full {
  position: fixed;
  top: 0;
  left: 0;
  width: 80vw;
  height: 80vh;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  overflow: auto;
}

.modal-content-full {
  background: #fff;
  width: 100%;
  height: 100%;
  padding: 20px;
  box-sizing: border-box;
  overflow-y: auto;
}

.documents-button {
  border-radius: 8px;
  width: 100%;
}

td .button.documents-button {
  padding: 1rem 0.5rem !important;
}

.entite-logo-placeholder {
  background-color: #e0e0e0;
  border: 1px solid #ccc;
  display: inline-block;
  width: 40px;
  height: 40px;
  border-radius: 4px;
}

.annuaire-loading .loading-indicator {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 4rem 5rem;
  min-height: 300px;
  background-color: #f9fafb;
  border-radius: 8px;
  margin: 1rem 5rem;
}

.loading-indicator .spinner {
  width: 48px;
  height: 48px;
  border: 4px solid #e5e7eb;
  border-top-color: #f97316;
  border-radius: 50%;
  animation: annuaire-spin 1s linear infinite;
  margin-bottom: 1.5rem;
}

@keyframes annuaire-spin {
  to {
    transform: rotate(360deg);
  }
}

.loading-indicator p {
  color: #6b7280;
  font-size: 1.6rem;
  font-weight: 500;
  margin: 0;
}

/* ============================================================
   VUE CARTES - Annuaire Prestataires
   ============================================================ */

.annuaire-cards-section {
  margin-top: 4rem;
  padding: 1rem 0;
}

.annuaire-cards-title {
  font-size: 1.8rem;
  color: #374151;
  margin-bottom: 2rem;
}

.annuaire-cards-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 1.2rem;
}

@media (min-width: 1600px) {
  .annuaire-cards-grid {
    grid-template-columns: repeat(6, 1fr);
  }
}

.prestataire-card {
  background: white;
  border-radius: 12px;
  overflow: visible;
  position: relative;
  min-width: 0;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  display: flex;
  flex-direction: column;
  transition:
    box-shadow 0.2s,
    transform 0.2s;
  cursor: pointer;
}

.prestataire-card:hover {
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.14);
  transform: translateY(-2px);
}

.prestataire-card--readonly {
  cursor: default;
}
.prestataire-card--readonly:hover {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  transform: none;
}

.prestataire-card-header {
  height: 120px;
  border-radius: 12px 12px 0 0;
  overflow: hidden;
  position: relative;
}

.prestataire-card-banner-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.prestataire-card-banner-placeholder {
  width: 100%;
  height: 100%;
  background-color: #e5e7eb;
}

.prestataire-card-logo-wrapper {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  top: 30px;
  width: 120px;
  height: 110px;
  background: white;
  border-radius: 10px;
  border: 2px solid #f3f4f6;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  z-index: 1;
}

.prestataire-card-logo-img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  padding: 6px;
}

.prestataire-card-logo-text {
  font-size: 1.5rem;
  font-weight: 800;
  color: #6b7280;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.prestataire-card-body {
  padding: 3.5rem 1.2rem 2rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.4rem;
  flex: 1 1;
  text-align: center;
}

.prestataire-card-nom {
  font-weight: 700;
  font-size: 1.35rem;
  color: #1f2937;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: center;
  width: 100%;
  margin: 0;
}

.prestataire-card-lot {
  font-size: 1.2rem;
  color: #6b7280;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: center;
  width: 100%;
  margin: 0;
}

.prestataire-card-type {
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;
  padding: 0.3rem 0.7rem;
  border-radius: 20px;
  font-size: 1.1rem;
  font-weight: 700;
  background-color: #f97316;
  color: white;
  z-index: 2;
  white-space: nowrap;
  max-width: calc(100% - 1rem);
  overflow: hidden;
  text-overflow: ellipsis;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.25);
}

.prestataire-card-type--libre {
  background-color: #d1d5db;
  color: #374151;
}

/* ── Carte suspendue ─────────────────────────────────────────────── */

.prestataire-card-inner {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  min-width: 0;
  overflow: hidden;
  border-radius: inherit;
  position: relative;
}

.prestataire-card--suspendu .prestataire-card-inner::after {
  content: "";
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.22);
  pointer-events: none;
  border-radius: inherit;
  z-index: 1;
}

.prestataire-card--suspendu {
  opacity: 0.9;
}

.prestataire-card--suspendu .prestataire-card-inner {
  filter: grayscale(70%) brightness(0.65);
}

.prestataire-card--suspendu:hover .prestataire-card-inner {
  filter: grayscale(60%) brightness(0.72);
}

.prestataire-card-badge-suspendu {
  position: absolute;
  top: 0.5rem;
  left: 0.5rem;
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  padding: 0.3rem 0.7rem;
  border-radius: 20px;
  font-size: 1.1rem;
  font-weight: 700;
  background-color: #ef4444;
  color: #fff;
  z-index: 3;
  white-space: nowrap;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.25);
}

.prestataire-card-stars {
  display: flex;
  align-items: center;
  gap: 0.35rem;
  margin-top: 0.4rem;
}

.stars-wrap {
  display: inline-flex;
  gap: 1px;
}

.star {
  font-size: 1.2rem;
  color: #d1d5db;
  position: relative;
  display: inline-block;
  line-height: 1;
}

.star--full {
  color: #f59e0b;
}

.star--half {
  color: #d1d5db;
}

.star-half {
  position: absolute;
  left: 0;
  top: 0;
  width: 50%;
  overflow: hidden;
  color: #f59e0b;
}

.star-bg {
  display: block;
}

.prestataire-card-avis {
  font-size: 1rem;
  color: #9ca3af;
  letter-spacing: normal;
}

/* ── Skeleton loading ──────────────────────────────────────────────── */

@keyframes sk-shimmer {
  0% {
    background-position: -200% 0;
  }
  100% {
    background-position: 200% 0;
  }
}

.prestataire-card-skeleton {
  pointer-events: none;
}

.prestataire-card-skeleton .sk {
  background: linear-gradient(90deg, #e5e7eb 25%, #f3f4f6 50%, #e5e7eb 75%);
  background-size: 200% 100%;
  animation: sk-shimmer 1.4s ease-in-out infinite;
  border-radius: 4px;
  display: block;
}

/* Banner fills the header zone */
.prestataire-card-skeleton .sk-banner {
  width: 100%;
  height: 100%;
  border-radius: 0;
}

/* Badge pill (top-right) */
.prestataire-card-skeleton .sk-badge {
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;
  width: 90px;
  height: 20px;
  border-radius: 20px;
  z-index: 2;
}

/* Logo square inside logo-wrapper */
.prestataire-card-skeleton .sk-logo {
  width: 100%;
  height: 100%;
  border-radius: 8px;
}

/* Text lines in body */
.prestataire-card-skeleton .sk-line {
  height: 13px;
  border-radius: 4px;
}

.prestataire-card-skeleton .sk-line--nom {
  width: 80%;
}

.prestataire-card-skeleton .sk-line--lot {
  width: 60%;
  margin-top: 2px;
}

/* Stars bar */
.prestataire-card-skeleton .sk-stars-bar {
  width: 80px;
  height: 12px;
  border-radius: 4px;
  margin-top: 6px;
  background: linear-gradient(90deg, #e5e7eb 25%, #f3f4f6 50%, #e5e7eb 75%);
  background-size: 200% 100%;
  animation: sk-shimmer 1.4s ease-in-out infinite;
  display: block;
}

.prestataire-card-btn {
  flex: 1 1;
  padding: 0.65rem 0.4rem;
  border-radius: 20px;
  border: none;
  cursor: pointer;
  font-size: 1.15rem;
  font-weight: 600;
  transition: opacity 0.2s;
}

.prestataire-card-btn:hover {
  opacity: 0.85;
}

.btn-fiche {
  background-color: #374151;
  color: white;
}

.btn-contacter {
  background-color: #f97316;
  color: white;
}

/* ============================================================
   Modal fiche prestataire
   ============================================================ */

.prestataire-fiche-modal {
  background: #fafafa;
  border-radius: 12px;
  width: 92vw;
  max-width: 1400px;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.25);
}

.fiche-modal-topbar {
  background: #fff;
  padding: 2rem 5rem 1.5rem 2.5rem;
  display: flex;
  align-items: center;
  gap: 1.5rem;
  flex-shrink: 0;
  position: relative;
  border-bottom: 1px solid #e5e7eb;
}

.fiche-modal-close {
  position: absolute;
  top: 1rem;
  right: 1.2rem;
  background: #f3f4f6;
  border: none;
  border-radius: 50%;
  width: 2.8rem;
  height: 2.8rem;
  font-size: 1.4rem;
  cursor: pointer;
  color: #374151;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.2s;
}

.fiche-modal-close:hover {
  background: #e5e7eb;
}

.fiche-modal-topbar-logo {
  flex-shrink: 0;
  width: 64px;
  height: 64px;
  border-radius: 10px;
  border: 1px solid #e5e7eb;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.fiche-modal-topbar-identity {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  min-width: 0;
}

.fiche-modal-nom {
  font-size: 1.8rem;
  font-weight: 600;
  color: #1f2937;
  margin: 0 0 0.4rem;
  line-height: 1.2;
}

.fiche-modal-type-badge {
  display: inline-block;
  padding: 0.25rem 0.9rem;
  border-radius: 20px;
  font-size: 1.1rem;
  font-weight: 600;
  background-color: #f97316;
  color: white;
  width: fit-content;
}

.fiche-modal-body {
  padding: 2rem 2.5rem 2.5rem;
  overflow-y: auto;
  flex: 1 1;
}

.fiche-modal-logo {
  width: 52px;
  height: 52px;
  object-fit: contain;
  padding: 4px;
}

.fiche-modal-logo-placeholder {
  width: 36px;
  height: 36px;
  background-color: rgba(0, 0, 0, 0.3);
  border-radius: 4px;
}

.fiche-modal-logo-fallback {
  padding: 4px;
}

.fiche-modal-section {
  margin-bottom: 2rem;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  overflow: hidden;
  background: #fff;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
}

.fiche-modal-section:last-child {
  margin-bottom: 0;
}

.fiche-modal-section p {
  margin: 0.3rem 0;
  font-size: 1.3rem;
  color: #374151;
}

.fiche-modal-section-title {
  background-color: #595959;
  color: #ffffff;
  padding: 1.25rem 1.5rem;
  font-size: 1.4rem;
  font-weight: 600;
  margin: 0;
  display: block;
  letter-spacing: normal;
  text-transform: none;
}

.fiche-modal-departements {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  padding: 1.5rem;
}

.fiche-modal-dep-chip {
  display: inline-flex;
  align-items: center;
  padding: 0.3rem 0.8rem;
  border-radius: 20px;
  background-color: #eef2ff;
  color: #4f71be;
  font-size: 1.15rem;
  font-weight: 500;
  white-space: nowrap;
}

.fiche-modal-section > p,
.fiche-modal-section
  > div:not(.fiche-modal-departements):not(.fiche-modal-dep-toggle) {
  padding: 1.5rem;
}

.fiche-modal-dep-toggle {
  margin-top: 0;
  padding: 0.5rem 1.5rem 1rem;
  background: none;
  border: none;
  color: #4f71be;
  font-size: 1.1rem;
  font-weight: 600;
  cursor: pointer;
  padding: 0;
  text-decoration: underline;
  text-underline-offset: 2px;
}

.fiche-modal-collapse-toggle {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  background: #595959;
  border: none;
  cursor: pointer;
  padding: 1.25rem 1.5rem;
  margin-bottom: 0;
}

.fiche-modal-collapse-toggle .fiche-modal-section-title {
  padding: 0;
  background: none;
  color: #fff;
}

.fiche-modal-collapse-toggle:hover .fiche-modal-section-title {
  color: #e5e7eb;
}

.fiche-modal-collapse-icon {
  font-size: 1rem;
  color: #9ca3af;
  transition: transform 0.2s;
  display: inline-block;
}

.fiche-modal-collapse-icon.expanded {
  transform: rotate(180deg);
}

.fiche-modal-collapse-arrow {
  width: 20px;
  height: 20px;
  flex-shrink: 0;
  fill: #ffffff;
}

.fiche-modal-contact-name {
  font-weight: 600;
  font-size: 1.35rem;
  color: #1f2937;
}

.fiche-modal-contact-detail {
  color: #6b7280;
}

.fiche-modal-contact-detail a {
  color: #4f71be;
  text-decoration: none;
}

.fiche-modal-contact-detail a:hover {
  text-decoration: underline;
}

.fiche-modal-footer {
  display: flex;
  justify-content: flex-end;
  padding: 1.4rem 2rem;
  border-top: 1px solid #e5e7eb;
  background: #fafafa;
  flex-shrink: 0;
}

/* ============================================================
   Modal documents (annuaire)
   ============================================================ */

.annuaire-docs-modal {
  background: white;
  border-radius: 14px;
  max-width: 680px;
  width: 90%;
  max-height: 88vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.18);
}

.annuaire-docs-modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1.6rem 2rem;
  border-bottom: 1px solid #e5e7eb;
  background: #fafafa;
  flex-shrink: 0;
}

.annuaire-docs-modal-title {
  font-size: 1.5rem;
  font-weight: 700;
  color: #1f2937;
  margin: 0;
}

.annuaire-docs-modal-body {
  padding: 2rem;
  overflow-y: auto;
  flex: 1 1;
}

/* ══════════════════════════════════════════════════════════════
   Onglet Acheteurs — toolbar, cartes, tableau
   ══════════════════════════════════════════════════════════════ */

.acheteurs-toolbar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  margin-bottom: 1.5rem;
}

.acheteurs-filters {
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
  align-items: center;
  flex: 1 1;
}

.acheteurs-filter-input,
.acheteurs-filter-select {
  height: 38px;
  padding: 0 0.75rem;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  font-size: 0.875rem;
  color: #374151;
  background: #fff;
  min-width: 180px;
  max-width: 260px;
}
.acheteurs-filter-input:focus,
.acheteurs-filter-select:focus {
  outline: none;
  border-color: #9ca3af;
}

.acheteurs-filter-clear {
  height: 38px;
  padding: 0 1rem;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  font-size: 0.85rem;
  color: #6b7280;
  background: #f9fafb;
  cursor: pointer;
}
.acheteurs-filter-clear:hover {
  background: #f3f4f6;
  color: #374151;
}

.acheteurs-view-toggle {
  display: flex;
  gap: 0.25rem;
  background: #f3f4f6;
  border-radius: 8px;
  padding: 3px;
  flex-shrink: 0;
}

.acheteurs-toggle-btn {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  padding: 0.4rem 0.85rem;
  border: none;
  border-radius: 6px;
  font-size: 0.85rem;
  color: #6b7280;
  background: transparent;
  cursor: pointer;
  transition:
    background 0.15s,
    color 0.15s;
}
.acheteurs-toggle-btn.active {
  background: #fff;
  color: #374151;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}
.acheteurs-toggle-btn:hover:not(.active) {
  color: #374151;
}

/* ── Grille ─────────────────────────────────────────────────── */

.acheteurs-cards-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 1.25rem;
}

/* ── Carte acheteur ─────────────────────────────────────────── */

.acheteur-card {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  padding: 1.4rem 1.2rem 1.2rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  cursor: pointer;
  position: relative;
  transition:
    box-shadow 0.2s,
    transform 0.2s;
  gap: 0.5rem;
}
.acheteur-card:hover {
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.13);
  transform: translateY(-2px);
}

/* badge rond en haut à droite */
.acheteur-badge-dot {
  position: absolute;
  top: 0.7rem;
  right: 0.7rem;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background: #e5e7eb;
  display: flex;
  align-items: center;
  justify-content: center;
}
.acheteur-badge-dot::after {
  content: "";
  display: block;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #9ca3af;
}
.acheteur-badge-dot--orange {
  background: #fff3e0;
}
.acheteur-badge-dot--orange::after {
  background: #f97316;
}

/* avatar initiales */
.acheteur-card-avatar {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background: #e5e7eb;
  color: #9ca3af;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.2rem;
  font-weight: 700;
  letter-spacing: 1px;
  margin-top: 0.2rem;
  flex-shrink: 0;
}

.acheteur-card-body {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.25rem;
  width: 100%;
}

.acheteur-card-nom {
  font-weight: 700;
  font-size: 0.88rem;
  color: #1f2937;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
  margin: 0;
}

.acheteur-card-dept {
  font-size: 0.78rem;
  color: #6b7280;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
  margin: 0;
}

.acheteur-card-categorie {
  display: inline-block;
  margin-top: 0.15rem;
  font-size: 0.73rem;
  color: #6b7280;
  background: #f3f4f6;
  border-radius: 4px;
  padding: 0.12rem 0.45rem;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* ── Skeleton acheteur ──────────────────────────────────────── */

@keyframes ac-shimmer {
  0% {
    background-position: -200% 0;
  }
  100% {
    background-position: 200% 0;
  }
}

.acheteur-card-skeleton {
  pointer-events: none;
}

.acheteur-card-skeleton .sk-badge-dot,
.acheteur-card-skeleton .sk-avatar,
.acheteur-card-skeleton .sk-ac {
  background: linear-gradient(90deg, #e5e7eb 25%, #f3f4f6 50%, #e5e7eb 75%);
  background-size: 200% 100%;
  animation: ac-shimmer 1.4s ease-in-out infinite;
}

.acheteur-card-skeleton .sk-badge-dot {
  border-radius: 50%;
}
.acheteur-card-skeleton .sk-badge-dot::after {
  display: none;
}

.acheteur-card-skeleton .sk-avatar {
  border-radius: 50%;
  color: transparent;
}

.sk-ac {
  display: block;
  border-radius: 4px;
}
.sk-ac-nom {
  height: 13px;
  width: 75%;
  margin: 0 auto;
}
.sk-ac-dept {
  height: 11px;
  width: 60%;
  margin: 3px auto 0;
}
.sk-ac-cat {
  height: 10px;
  width: 45%;
  margin: 4px auto 0;
  border-radius: 4px;
}

/* ── Tableau acheteurs ──────────────────────────────────────── */

.acheteurs-table-wrapper {
  overflow-x: auto;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.07);
}

.acheteurs-table {
  width: 100%;
  border-collapse: collapse;
  background: #fff;
  font-size: 0.9rem;
}

.acheteurs-table th {
  background: #f3f4f6;
  color: #595959;
  font-weight: 600;
  font-size: 0.8rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  padding: 0.75rem 1rem;
  text-align: left;
  border-bottom: 2px solid #e5e7eb;
}

.acheteurs-table td {
  padding: 0.75rem 1rem;
  color: #374151;
  border-bottom: 1px solid #f3f4f6;
  vertical-align: middle;
}

.acheteurs-table-row {
  cursor: pointer;
  transition: background 0.1s;
}
.acheteurs-table-row:hover {
  background: #f9fafb;
}
.acheteurs-table-nom {
  font-weight: 600;
}

.acheteurs-non-renseigne {
  color: #9ca3af;
  font-style: italic;
}

.acheteur-recent-badge {
  display: inline-block;
  padding: 0.15rem 0.6rem;
  border-radius: 12px;
  font-size: 0.78rem;
  font-weight: 600;
  background: #f3f4f6;
  color: #9ca3af;
}
.acheteur-recent-badge--orange {
  background: #fff3e0;
  color: #f97316;
}

.acheteurs-empty {
  color: #9ca3af;
  font-style: italic;
  padding: 2rem 0;
  text-align: center;
}

/* ── Chip catégorie sous la ligne département ── */

.prestataire-card-categorie {
  display: inline-block;
  margin-top: 0.25rem;
  font-size: 1.2rem;
  color: #374151;
  background: #f3f4f6;
  border-radius: 4px;
  padding: 0.15rem 0.6rem;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-weight: 500;
}

/* Signup prompt pour non-connectés */
.annuaire-signup-prompt {
  position: relative;
  background: #fff;
  border-radius: 16px;
  padding: 2.5rem 2rem 2rem;
  max-width: 420px;
  width: 90%;
  text-align: center;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.18);
}

.annuaire-signup-prompt .fiche-modal-close {
  position: absolute;
  top: 1rem;
  right: 1rem;
}

.annuaire-signup-prompt-icon {
  font-size: 2.5rem;
  margin-bottom: 1rem;
}

.annuaire-signup-prompt-title {
  font-size: 1.65rem;
  font-weight: 700;
  color: #1f2937;
  margin-bottom: 0.85rem;
}

.annuaire-signup-prompt-text {
  font-size: 1.2rem;
  color: #6b7280;
  line-height: 1.65;
  margin-bottom: 1.75rem;
}

.annuaire-signup-prompt-actions {
  display: flex;
  gap: 1rem;
  justify-content: center;
  flex-wrap: wrap;
}

.annuaire-signup-prompt-btn {
  padding: 0.7rem 1.6rem;
  border-radius: 8px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  border: none;
  transition: opacity 0.15s;
}

.annuaire-signup-prompt-btn:hover {
  opacity: 0.88;
}

.annuaire-signup-prompt-btn--primary {
  background: #f97316;
  color: #fff;
}

.annuaire-signup-prompt-btn--secondary {
  background: #f3f4f6;
  color: #374151;
  border: 1px solid #e5e7eb;
}

/* Les cartes non-connectées sont cliquables */
.prestataire-card--readonly:not([class*="suspendu"]) {
  cursor: pointer;
}

.prestataire-card--readonly:not([class*="suspendu"]):hover {
  box-shadow: 0 4px 16px rgba(249, 115, 22, 0.15);
  transform: translateY(-2px);
}
`, "",{"version":3,"sources":["webpack://./src/pages/Annuaire/Annuaire.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA,mDAAmD;AACnD;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA,qDAAqD;AACrD;EACE,oBAAoB;EACpB,mBAAmB;EACnB,6BAA6B;EAC7B,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,mDAAmD;AACnD;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,wBAAwB;EACxB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA,sCAAsC;AACtC;EACE,kBAAkB;EAClB,OAAO;EACP,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,0CAA0C;EAC1C,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,UAAU;EACV,kBAAkB;EAClB,0BAA0B;EAC1B;;;kBAGgB;AAClB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,sBAAsB;AACxB;;AAEA,mEAAmE;AACnE;EACE,YAAY;EACZ,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,UAAU;EACV,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;;;;GAIG;;AAEH;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,0CAA0C;EAC1C,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB,EAAE,+CAA+C;AAC5E;;AAEA;EACE,2CAA2C,EAAE,8BAA8B;AAC7E;;AAEA;EACE,yBAAyB,EAAE,gDAAgD;EAC3E,0BAA0B,EAAE,8BAA8B;AAC5D;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,sBAAsB,EAAE,0CAA0C;AACpE;;AAEA;EACE,cAAc,EAAE,wCAAwC;AAC1D;;AAEA;EACE,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,0BAA0B;EAC1B,cAAc;AAChB;;AAEA,yCAAyC;AACzC;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,+BAA+B;AACjC;;AAEA,qCAAqC;AACrC;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA,4DAA4D;AAC5D;EACE,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,qCAAqC;AACrC;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,qBAAqB;EACrB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,SAAO;AACT;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;;;;;;;GAQG;;AAEH;EACE,qBAAqB;EACrB,aAAa;AACf;;AAEA,qBAAqB;AACrB;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW,EAAE,oBAAoB;EACjC,YAAY,EAAE,oBAAoB;EAClC,mBAAmB,EAAE,2CAA2C;EAChE,gBAAgB,EAAE,kDAAkD;EACpE,kBAAkB,EAAE,8BAA8B;EAClD,sBAAsB,EAAE,6BAA6B;AACvD;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,yBAAyB,EAAE,eAAe;EAC1C,6BAA6B,EAAE,SAAS;EACxC,kBAAkB;EAClB,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,2CAA2C;EAC3C,qBAAqB;AACvB;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;AACX;;AAEA;;iEAEiE;;AAEjE;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,WAAW;AACb;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,yCAAyC;EACzC,aAAa;EACb,sBAAsB;EACtB;;kBAEgB;EAChB,eAAe;AACjB;;AAEA;EACE,0CAA0C;EAC1C,2BAA2B;AAC7B;;AAEA;EACE,eAAe;AACjB;AACA;EACE,yCAAyC;EACzC,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,4BAA4B;EAC5B,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,2BAA2B;EAC3B,SAAS;EACT,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,wCAAwC;EACxC,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,SAAO;EACP,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;EAClB,WAAW;EACX,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;EAClB,WAAW;EACX,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,YAAY;EACZ,UAAU;EACV,mBAAmB;EACnB,4BAA4B;EAC5B,gBAAgB;EAChB,uBAAuB;EACvB,yCAAyC;AAC3C;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA,uEAAuE;;AAEvE;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,+BAA+B;EAC/B,oBAAoB;EACpB,sBAAsB;EACtB,UAAU;AACZ;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,sBAAsB;EACtB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,WAAW;EACX,UAAU;EACV,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,UAAU;EACV,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,sBAAsB;AACxB;;AAEA,yEAAyE;;AAEzE;EACE;IACE,4BAA4B;EAC9B;EACA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,yEAAyE;EACzE,0BAA0B;EAC1B,+CAA+C;EAC/C,kBAAkB;EAClB,cAAc;AAChB;;AAEA,iCAAiC;AACjC;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA,2BAA2B;AAC3B;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,UAAU;AACZ;;AAEA,oCAAoC;AACpC;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA,uBAAuB;AACvB;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,eAAe;AACjB;;AAEA,cAAc;AACd;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,yEAAyE;EACzE,0BAA0B;EAC1B,+CAA+C;EAC/C,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;;iEAEiE;;AAEjE;EACE,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,2CAA2C;AAC7C;;AAEA;EACE,gBAAgB;EAChB,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,SAAO;AACT;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;EACT,cAAc;EACd,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,sBAAsB;EACtB,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;;EAGE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,UAAU;EACV,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,0BAA0B;EAC1B,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,oBAAoB;EACpB,6BAA6B;EAC7B,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;iEAEiE;;AAEjE;EACE,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,oBAAoB;EACpB,gCAAgC;EAChC,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,SAAO;AACT;;AAEA;;mEAEmE;;AAEnE;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,SAAO;AACT;;AAEA;;EAEE,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;AACA;;EAEE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,uBAAuB;EACvB,eAAe;EACf;;eAEa;AACf;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,wCAAwC;AAC1C;AACA;EACE,cAAc;AAChB;;AAEA,kEAAkE;;AAElE;EACE,aAAa;EACb,4DAA4D;EAC5D,YAAY;AACd;;AAEA,kEAAkE;;AAElE;EACE,gBAAgB;EAChB,mBAAmB;EACnB,yCAAyC;EACzC,6BAA6B;EAC7B,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB;;kBAEgB;EAChB,WAAW;AACb;AACA;EACE,0CAA0C;EAC1C,2BAA2B;AAC7B;;AAEA,gCAAgC;AAChC;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,WAAW;EACX,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;;AAEA,qBAAqB;AACrB;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,WAAW;EACX,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,WAAW;EACX,SAAS;AACX;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,kEAAkE;;AAElE;EACE;IACE,4BAA4B;EAC9B;EACA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE,oBAAoB;AACtB;;AAEA;;;EAGE,yEAAyE;EACzE,0BAA0B;EAC1B,+CAA+C;AACjD;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,UAAU;EACV,cAAc;AAChB;AACA;EACE,YAAY;EACZ,UAAU;EACV,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,UAAU;EACV,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA,kEAAkE;;AAElE;EACE,gBAAgB;EAChB,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,sBAAsB;EACtB,qBAAqB;EACrB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,2BAA2B;AAC7B;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,kBAAkB;AACpB;;AAEA,mDAAmD;;AAEnD;EACE,qBAAqB;EACrB,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,qCAAqC;AACrC;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,UAAU;EACV,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA,8CAA8C;AAC9C;EACE,eAAe;AACjB;;AAEA;EACE,+CAA+C;EAC/C,2BAA2B;AAC7B","sourcesContent":[".annuaire-page {\r\n  width: 100%;\r\n  padding: 0;\r\n}\r\n\r\n.annuaire-page h1 {\r\n  margin-bottom: 3rem;\r\n}\r\n\r\n.annuaire-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  margin: 2rem 0;\r\n}\r\n\r\n.header-actions {\r\n  display: flex;\r\n  gap: 1rem;\r\n}\r\n\r\n.entreprise-info {\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.avatar-placeholder {\r\n  width: 4rem;\r\n  height: 4rem;\r\n  border-radius: 50%;\r\n  background-color: #e5e7eb;\r\n  overflow: hidden;\r\n}\r\n\r\n.action-button {\r\n  background: none;\r\n  border: none;\r\n  cursor: pointer;\r\n  font-size: 1.8rem;\r\n  color: #2c3948;\r\n}\r\n\r\n.action-button:hover {\r\n  color: #f97316;\r\n}\r\n\r\n.entreprise-cell {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 1rem;\r\n}\r\n\r\n.entreprise-logo {\r\n  width: 50px;\r\n  height: 50px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  overflow: hidden;\r\n  border-radius: 4px;\r\n}\r\n\r\n.entreprise-logo img {\r\n  max-width: 100%;\r\n  max-height: 100%;\r\n  object-fit: contain;\r\n}\r\n\r\n.entreprise-nom {\r\n  font-weight: 500;\r\n}\r\n\r\n.information-cell {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 0.25rem;\r\n}\r\n\r\n.contact-name {\r\n  font-weight: 700;\r\n}\r\n\r\n/* Remplacer le style existant des documents-cell */\r\n.documents-cell {\r\n  position: relative;\r\n  /* max-width: 60px; */\r\n}\r\n\r\n/* Style pour le bouton qui affichera les documents */\r\n.documents-toggle {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  background-color: transparent;\r\n  border: none;\r\n  padding: 0.25rem;\r\n  font-size: 0.8rem;\r\n  cursor: pointer;\r\n  color: #2c3948;\r\n  transition: color 0.2s;\r\n  white-space: nowrap;\r\n}\r\n\r\n.documents-toggle:hover {\r\n  color: #f97316;\r\n}\r\n\r\n.documents-toggle svg {\r\n  width: 30px;\r\n  height: 30px;\r\n}\r\n\r\n/* Style pour le bouton qui n'affiche que l'icône */\r\n.documents-toggle.documents-icon-counter {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  /* background: transparent; */\r\n  border: none;\r\n  padding: 4px;\r\n  cursor: pointer;\r\n  transition: transform 0.2s ease;\r\n}\r\n\r\n.documents-toggle.documents-icon-counter:hover {\r\n  /* transform: scale(1.2); */\r\n}\r\n\r\n.document-outline-icon {\r\n  width: 24px;\r\n  height: 24px;\r\n}\r\n\r\n.documents-count {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  /* border-radius: 50%; */\r\n  width: 18px;\r\n  height: 18px;\r\n  font-size: 1.5rem;\r\n  margin-left: 0.25rem;\r\n}\r\n\r\n/* Popup pour afficher les documents */\r\n.documents-popup {\r\n  position: absolute;\r\n  top: 0%;\r\n  left: -279px;\r\n  margin-bottom: 4px;\r\n  background-color: white;\r\n  border: 1px solid #e5e7eb;\r\n  border-radius: 6px;\r\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\r\n  padding: 12px;\r\n  z-index: 100;\r\n  min-width: 280px;\r\n  max-width: 400px;\r\n  opacity: 0;\r\n  visibility: hidden;\r\n  transform: translateY(8px);\r\n  transition:\r\n    opacity 0.2s,\r\n    visibility 0.2s,\r\n    transform 0.2s;\r\n}\r\n\r\n.documents-popup-list {\r\n  display: flex;\r\n  gap: 0.5rem;\r\n  flex-direction: column;\r\n}\r\n\r\n/* Pour les lignes en bas du tableau, afficher le popup au-dessus */\r\n.tableau-de-bord-table tr:nth-last-child(-n + 3) .documents-popup {\r\n  bottom: auto;\r\n  top: 100%;\r\n  margin-top: 4px;\r\n  margin-bottom: 0;\r\n  transform: translateY(-8px);\r\n}\r\n\r\n.documents-cell:hover .documents-popup {\r\n  opacity: 1;\r\n  visibility: visible;\r\n  transform: translateY(0);\r\n}\r\n\r\n/* .documents-list {\r\n  display: grid;\r\n  grid-template-columns: 1fr 1fr;\r\n  gap: 0.75rem;\r\n} */\r\n\r\n.annuaire-page .document-item {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  background-color: rgba(215, 217, 217, 0.2);\r\n  text-decoration: none;\r\n  font-size: 0.85rem;\r\n  padding: 6px 8px;\r\n  border-radius: 4px;\r\n  transition: all 0.2s ease; /* Transition douce pour tous les changements */\r\n}\r\n\r\n.annuaire-page .document-item:hover {\r\n  background-color: rgba(194, 194, 194, 0.46); /* Couleur de fond au survol */\r\n}\r\n\r\n.annuaire-page .document-item:active {\r\n  background-color: #e5e7eb; /* Couleur légèrement plus foncée lors du clic */\r\n  transform: translateY(1px); /* Léger effet d'enfoncement */\r\n}\r\n\r\n.annuaire-page .document-item .document-icon {\r\n  width: 16px;\r\n  height: 16px;\r\n  flex-shrink: 0;\r\n  transition: color 0.2s; /* Transition pour la couleur de l'icône */\r\n}\r\n\r\n.annuaire-page .document-item:hover .document-icon {\r\n  color: #f97316; /* Même couleur que le texte au survol */\r\n}\r\n\r\n.annuaire-page .document-item svg {\r\n  width: 16px;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.document-link {\r\n  color: #2c3948;\r\n  text-decoration: none;\r\n  font-size: 0.875rem;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n}\r\n\r\n.document-link:hover {\r\n  text-decoration: underline;\r\n  color: #f97316;\r\n}\r\n\r\n/* Animation pour l'apparition du popup */\r\n@keyframes fadeIn {\r\n  from {\r\n    opacity: 0;\r\n    transform: translateY(-5px);\r\n  }\r\n  to {\r\n    opacity: 1;\r\n    transform: translateY(0);\r\n  }\r\n}\r\n\r\n.documents-popup {\r\n  animation: fadeIn 0.2s ease-out;\r\n}\r\n\r\n/* Styles pour l'en-tête du tableau */\r\n.tableau-de-bord-header {\r\n  background-color: #f3f4f6;\r\n  font-weight: 600;\r\n}\r\n\r\n/* Définir des largeurs fixes pour les colonnes du tableau */\r\n.categorie-cell {\r\n  max-width: 150px;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n}\r\n\r\n.departement-cell {\r\n  max-width: 120px;\r\n  white-space: nowrap;\r\n}\r\n\r\n.rang-cell {\r\n  max-width: 60px;\r\n  text-align: center;\r\n}\r\n\r\n.entreprise-cell {\r\n  max-width: 200px;\r\n}\r\n\r\n.information-cell {\r\n  max-width: 180px;\r\n}\r\n\r\n/* Styles pour les filtres dropdown */\r\n.annuaire-filters {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: 1rem;\r\n  margin: 3rem 0 1.5rem;\r\n  padding: 1rem 0;\r\n  border-radius: 0.5rem;\r\n}\r\n\r\n.filter-dropdown {\r\n  display: flex;\r\n  flex-direction: column;\r\n  min-width: 200px;\r\n  flex: 1;\r\n}\r\n\r\n.filter-dropdown label {\r\n  margin-bottom: 0.5rem;\r\n  /* font-size: 0.875rem; */\r\n  font-weight: 500;\r\n  color: #606060;\r\n}\r\n\r\n/* .filter-dropdown select {\r\n  padding: 0.5rem 1rem;\r\n  border: 1px solid #ddd;\r\n  border-radius: 0.25rem;\r\n  background-color: white;\r\n  font-size: 0.875rem;\r\n  height: 40px;\r\n  transition: border-color 0.2s;\r\n} */\r\n\r\n.filter-dropdown select:focus {\r\n  border-color: #f97316;\r\n  outline: none;\r\n}\r\n\r\n/* Style responsive */\r\n@media (max-width: 768px) {\r\n  .annuaire-filters {\r\n    flex-direction: column;\r\n  }\r\n\r\n  .filter-dropdown {\r\n    width: 100%;\r\n  }\r\n}\r\n\r\n.acheteur-localisation-cell {\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n.code-postal {\r\n  font-size: 14px;\r\n}\r\n\r\n.country-flag {\r\n  font-size: 16px;\r\n}\r\n\r\n.entite-logo {\r\n  width: 40px; /* largeur du logo */\r\n  height: 40px; /* hauteur du logo */\r\n  object-fit: contain; /* pour que l’image garde ses proportions */\r\n  margin-left: 8px; /* espacement par rapport au nom de l’entreprise */\r\n  border-radius: 4px; /* coins légèrement arrondis */\r\n  vertical-align: middle; /* alignement avec le texte */\r\n}\r\n\r\n.entite-logo-spinner {\r\n  width: 1em !important;\r\n  height: 1em !important;\r\n  border: 4px solid #f3f3f3; /* gris clair */\r\n  border-top: 4px solid #3498db; /* bleu */\r\n  border-radius: 50%;\r\n  animation: spin 1s linear infinite;\r\n  margin-left: 8px;\r\n}\r\n\r\n@keyframes spin {\r\n  0% {\r\n    transform: rotate(0deg);\r\n  }\r\n  100% {\r\n    transform: rotate(360deg);\r\n  }\r\n}\r\n\r\n.modal-overlay-full {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  width: 80vw;\r\n  height: 80vh;\r\n  background-color: rgba(0, 0, 0, 0.6);\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  z-index: 9999;\r\n  overflow: auto;\r\n}\r\n\r\n.modal-content-full {\r\n  background: #fff;\r\n  width: 100%;\r\n  height: 100%;\r\n  padding: 20px;\r\n  box-sizing: border-box;\r\n  overflow-y: auto;\r\n}\r\n\r\n.documents-button {\r\n  border-radius: 8px;\r\n  width: 100%;\r\n}\r\n\r\ntd .button.documents-button {\r\n  padding: 1rem 0.5rem !important;\r\n}\r\n\r\n.entite-logo-placeholder {\r\n  background-color: #e0e0e0;\r\n  border: 1px solid #ccc;\r\n  display: inline-block;\r\n  width: 40px;\r\n  height: 40px;\r\n  border-radius: 4px;\r\n}\r\n\r\n.annuaire-loading .loading-indicator {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: 4rem 5rem;\r\n  min-height: 300px;\r\n  background-color: #f9fafb;\r\n  border-radius: 8px;\r\n  margin: 1rem 5rem;\r\n}\r\n\r\n.loading-indicator .spinner {\r\n  width: 48px;\r\n  height: 48px;\r\n  border: 4px solid #e5e7eb;\r\n  border-top-color: #f97316;\r\n  border-radius: 50%;\r\n  animation: annuaire-spin 1s linear infinite;\r\n  margin-bottom: 1.5rem;\r\n}\r\n\r\n@keyframes annuaire-spin {\r\n  to {\r\n    transform: rotate(360deg);\r\n  }\r\n}\r\n\r\n.loading-indicator p {\r\n  color: #6b7280;\r\n  font-size: 1.6rem;\r\n  font-weight: 500;\r\n  margin: 0;\r\n}\r\n\r\n/* ============================================================\r\n   VUE CARTES - Annuaire Prestataires\r\n   ============================================================ */\r\n\r\n.annuaire-cards-section {\r\n  margin-top: 4rem;\r\n  padding: 1rem 0;\r\n}\r\n\r\n.annuaire-cards-title {\r\n  font-size: 1.8rem;\r\n  color: #374151;\r\n  margin-bottom: 2rem;\r\n}\r\n\r\n.annuaire-cards-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(4, 1fr);\r\n  gap: 1.2rem;\r\n}\r\n\r\n@media (min-width: 1600px) {\r\n  .annuaire-cards-grid {\r\n    grid-template-columns: repeat(6, 1fr);\r\n  }\r\n}\r\n\r\n.prestataire-card {\r\n  background: white;\r\n  border-radius: 12px;\r\n  overflow: visible;\r\n  position: relative;\r\n  min-width: 0;\r\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);\r\n  display: flex;\r\n  flex-direction: column;\r\n  transition:\r\n    box-shadow 0.2s,\r\n    transform 0.2s;\r\n  cursor: pointer;\r\n}\r\n\r\n.prestataire-card:hover {\r\n  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.14);\r\n  transform: translateY(-2px);\r\n}\r\n\r\n.prestataire-card--readonly {\r\n  cursor: default;\r\n}\r\n.prestataire-card--readonly:hover {\r\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);\r\n  transform: none;\r\n}\r\n\r\n.prestataire-card-header {\r\n  height: 120px;\r\n  border-radius: 12px 12px 0 0;\r\n  overflow: hidden;\r\n  position: relative;\r\n}\r\n\r\n.prestataire-card-banner-img {\r\n  width: 100%;\r\n  height: 100%;\r\n  object-fit: cover;\r\n}\r\n\r\n.prestataire-card-banner-placeholder {\r\n  width: 100%;\r\n  height: 100%;\r\n  background-color: #e5e7eb;\r\n}\r\n\r\n.prestataire-card-logo-wrapper {\r\n  position: absolute;\r\n  left: 50%;\r\n  transform: translateX(-50%);\r\n  top: 30px;\r\n  width: 120px;\r\n  height: 110px;\r\n  background: white;\r\n  border-radius: 10px;\r\n  border: 2px solid #f3f4f6;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  overflow: hidden;\r\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\r\n  z-index: 1;\r\n}\r\n\r\n.prestataire-card-logo-img {\r\n  width: 100%;\r\n  height: 100%;\r\n  object-fit: contain;\r\n  padding: 6px;\r\n}\r\n\r\n.prestataire-card-logo-text {\r\n  font-size: 1.5rem;\r\n  font-weight: 800;\r\n  color: #6b7280;\r\n  letter-spacing: 0.08em;\r\n  text-transform: uppercase;\r\n}\r\n\r\n.prestataire-card-body {\r\n  padding: 3.5rem 1.2rem 2rem;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  gap: 0.4rem;\r\n  flex: 1;\r\n  text-align: center;\r\n}\r\n\r\n.prestataire-card-nom {\r\n  font-weight: 700;\r\n  font-size: 1.35rem;\r\n  color: #1f2937;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  text-align: center;\r\n  width: 100%;\r\n  margin: 0;\r\n}\r\n\r\n.prestataire-card-lot {\r\n  font-size: 1.2rem;\r\n  color: #6b7280;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  text-align: center;\r\n  width: 100%;\r\n  margin: 0;\r\n}\r\n\r\n.prestataire-card-type {\r\n  position: absolute;\r\n  top: 0.5rem;\r\n  right: 0.5rem;\r\n  padding: 0.3rem 0.7rem;\r\n  border-radius: 20px;\r\n  font-size: 1.1rem;\r\n  font-weight: 700;\r\n  background-color: #f97316;\r\n  color: white;\r\n  z-index: 2;\r\n  white-space: nowrap;\r\n  max-width: calc(100% - 1rem);\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.25);\r\n}\r\n\r\n.prestataire-card-type--libre {\r\n  background-color: #d1d5db;\r\n  color: #374151;\r\n}\r\n\r\n/* ── Carte suspendue ─────────────────────────────────────────────── */\r\n\r\n.prestataire-card-inner {\r\n  flex: 1;\r\n  display: flex;\r\n  flex-direction: column;\r\n  min-width: 0;\r\n  overflow: hidden;\r\n  border-radius: inherit;\r\n  position: relative;\r\n}\r\n\r\n.prestataire-card--suspendu .prestataire-card-inner::after {\r\n  content: \"\";\r\n  position: absolute;\r\n  inset: 0;\r\n  background: rgba(0, 0, 0, 0.22);\r\n  pointer-events: none;\r\n  border-radius: inherit;\r\n  z-index: 1;\r\n}\r\n\r\n.prestataire-card--suspendu {\r\n  opacity: 0.9;\r\n}\r\n\r\n.prestataire-card--suspendu .prestataire-card-inner {\r\n  filter: grayscale(70%) brightness(0.65);\r\n}\r\n\r\n.prestataire-card--suspendu:hover .prestataire-card-inner {\r\n  filter: grayscale(60%) brightness(0.72);\r\n}\r\n\r\n.prestataire-card-badge-suspendu {\r\n  position: absolute;\r\n  top: 0.5rem;\r\n  left: 0.5rem;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 0.35rem;\r\n  padding: 0.3rem 0.7rem;\r\n  border-radius: 20px;\r\n  font-size: 1.1rem;\r\n  font-weight: 700;\r\n  background-color: #ef4444;\r\n  color: #fff;\r\n  z-index: 3;\r\n  white-space: nowrap;\r\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.25);\r\n}\r\n\r\n.prestataire-card-stars {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.35rem;\r\n  margin-top: 0.4rem;\r\n}\r\n\r\n.stars-wrap {\r\n  display: inline-flex;\r\n  gap: 1px;\r\n}\r\n\r\n.star {\r\n  font-size: 1.2rem;\r\n  color: #d1d5db;\r\n  position: relative;\r\n  display: inline-block;\r\n  line-height: 1;\r\n}\r\n\r\n.star--full {\r\n  color: #f59e0b;\r\n}\r\n\r\n.star--half {\r\n  color: #d1d5db;\r\n}\r\n\r\n.star-half {\r\n  position: absolute;\r\n  left: 0;\r\n  top: 0;\r\n  width: 50%;\r\n  overflow: hidden;\r\n  color: #f59e0b;\r\n}\r\n\r\n.star-bg {\r\n  display: block;\r\n}\r\n\r\n.prestataire-card-avis {\r\n  font-size: 1rem;\r\n  color: #9ca3af;\r\n  letter-spacing: normal;\r\n}\r\n\r\n/* ── Skeleton loading ──────────────────────────────────────────────── */\r\n\r\n@keyframes sk-shimmer {\r\n  0% {\r\n    background-position: -200% 0;\r\n  }\r\n  100% {\r\n    background-position: 200% 0;\r\n  }\r\n}\r\n\r\n.prestataire-card-skeleton {\r\n  pointer-events: none;\r\n}\r\n\r\n.prestataire-card-skeleton .sk {\r\n  background: linear-gradient(90deg, #e5e7eb 25%, #f3f4f6 50%, #e5e7eb 75%);\r\n  background-size: 200% 100%;\r\n  animation: sk-shimmer 1.4s ease-in-out infinite;\r\n  border-radius: 4px;\r\n  display: block;\r\n}\r\n\r\n/* Banner fills the header zone */\r\n.prestataire-card-skeleton .sk-banner {\r\n  width: 100%;\r\n  height: 100%;\r\n  border-radius: 0;\r\n}\r\n\r\n/* Badge pill (top-right) */\r\n.prestataire-card-skeleton .sk-badge {\r\n  position: absolute;\r\n  top: 0.5rem;\r\n  right: 0.5rem;\r\n  width: 90px;\r\n  height: 20px;\r\n  border-radius: 20px;\r\n  z-index: 2;\r\n}\r\n\r\n/* Logo square inside logo-wrapper */\r\n.prestataire-card-skeleton .sk-logo {\r\n  width: 100%;\r\n  height: 100%;\r\n  border-radius: 8px;\r\n}\r\n\r\n/* Text lines in body */\r\n.prestataire-card-skeleton .sk-line {\r\n  height: 13px;\r\n  border-radius: 4px;\r\n}\r\n\r\n.prestataire-card-skeleton .sk-line--nom {\r\n  width: 80%;\r\n}\r\n\r\n.prestataire-card-skeleton .sk-line--lot {\r\n  width: 60%;\r\n  margin-top: 2px;\r\n}\r\n\r\n/* Stars bar */\r\n.prestataire-card-skeleton .sk-stars-bar {\r\n  width: 80px;\r\n  height: 12px;\r\n  border-radius: 4px;\r\n  margin-top: 6px;\r\n  background: linear-gradient(90deg, #e5e7eb 25%, #f3f4f6 50%, #e5e7eb 75%);\r\n  background-size: 200% 100%;\r\n  animation: sk-shimmer 1.4s ease-in-out infinite;\r\n  display: block;\r\n}\r\n\r\n.prestataire-card-btn {\r\n  flex: 1;\r\n  padding: 0.65rem 0.4rem;\r\n  border-radius: 20px;\r\n  border: none;\r\n  cursor: pointer;\r\n  font-size: 1.15rem;\r\n  font-weight: 600;\r\n  transition: opacity 0.2s;\r\n}\r\n\r\n.prestataire-card-btn:hover {\r\n  opacity: 0.85;\r\n}\r\n\r\n.btn-fiche {\r\n  background-color: #374151;\r\n  color: white;\r\n}\r\n\r\n.btn-contacter {\r\n  background-color: #f97316;\r\n  color: white;\r\n}\r\n\r\n/* ============================================================\r\n   Modal fiche prestataire\r\n   ============================================================ */\r\n\r\n.prestataire-fiche-modal {\r\n  background: #fafafa;\r\n  border-radius: 12px;\r\n  width: 92vw;\r\n  max-width: 1400px;\r\n  max-height: 90vh;\r\n  display: flex;\r\n  flex-direction: column;\r\n  overflow: hidden;\r\n  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.25);\r\n}\r\n\r\n.fiche-modal-topbar {\r\n  background: #fff;\r\n  padding: 2rem 5rem 1.5rem 2.5rem;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 1.5rem;\r\n  flex-shrink: 0;\r\n  position: relative;\r\n  border-bottom: 1px solid #e5e7eb;\r\n}\r\n\r\n.fiche-modal-close {\r\n  position: absolute;\r\n  top: 1rem;\r\n  right: 1.2rem;\r\n  background: #f3f4f6;\r\n  border: none;\r\n  border-radius: 50%;\r\n  width: 2.8rem;\r\n  height: 2.8rem;\r\n  font-size: 1.4rem;\r\n  cursor: pointer;\r\n  color: #374151;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  transition: background 0.2s;\r\n}\r\n\r\n.fiche-modal-close:hover {\r\n  background: #e5e7eb;\r\n}\r\n\r\n.fiche-modal-topbar-logo {\r\n  flex-shrink: 0;\r\n  width: 64px;\r\n  height: 64px;\r\n  border-radius: 10px;\r\n  border: 1px solid #e5e7eb;\r\n  background: #fff;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  overflow: hidden;\r\n}\r\n\r\n.fiche-modal-topbar-identity {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 0.5rem;\r\n  min-width: 0;\r\n}\r\n\r\n.fiche-modal-nom {\r\n  font-size: 1.8rem;\r\n  font-weight: 600;\r\n  color: #1f2937;\r\n  margin: 0 0 0.4rem;\r\n  line-height: 1.2;\r\n}\r\n\r\n.fiche-modal-type-badge {\r\n  display: inline-block;\r\n  padding: 0.25rem 0.9rem;\r\n  border-radius: 20px;\r\n  font-size: 1.1rem;\r\n  font-weight: 600;\r\n  background-color: #f97316;\r\n  color: white;\r\n  width: fit-content;\r\n}\r\n\r\n.fiche-modal-body {\r\n  padding: 2rem 2.5rem 2.5rem;\r\n  overflow-y: auto;\r\n  flex: 1;\r\n}\r\n\r\n.fiche-modal-logo {\r\n  width: 52px;\r\n  height: 52px;\r\n  object-fit: contain;\r\n  padding: 4px;\r\n}\r\n\r\n.fiche-modal-logo-placeholder {\r\n  width: 36px;\r\n  height: 36px;\r\n  background-color: rgba(0, 0, 0, 0.3);\r\n  border-radius: 4px;\r\n}\r\n\r\n.fiche-modal-logo-fallback {\r\n  padding: 4px;\r\n}\r\n\r\n.fiche-modal-section {\r\n  margin-bottom: 2rem;\r\n  border: 1px solid #e5e7eb;\r\n  border-radius: 10px;\r\n  overflow: hidden;\r\n  background: #fff;\r\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);\r\n}\r\n\r\n.fiche-modal-section:last-child {\r\n  margin-bottom: 0;\r\n}\r\n\r\n.fiche-modal-section p {\r\n  margin: 0.3rem 0;\r\n  font-size: 1.3rem;\r\n  color: #374151;\r\n}\r\n\r\n.fiche-modal-section-title {\r\n  background-color: #595959;\r\n  color: #ffffff;\r\n  padding: 1.25rem 1.5rem;\r\n  font-size: 1.4rem;\r\n  font-weight: 600;\r\n  margin: 0;\r\n  display: block;\r\n  letter-spacing: normal;\r\n  text-transform: none;\r\n}\r\n\r\n.fiche-modal-departements {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: 0.5rem;\r\n  padding: 1.5rem;\r\n}\r\n\r\n.fiche-modal-dep-chip {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  padding: 0.3rem 0.8rem;\r\n  border-radius: 20px;\r\n  background-color: #eef2ff;\r\n  color: #4f71be;\r\n  font-size: 1.15rem;\r\n  font-weight: 500;\r\n  white-space: nowrap;\r\n}\r\n\r\n.fiche-modal-section > p,\r\n.fiche-modal-section\r\n  > div:not(.fiche-modal-departements):not(.fiche-modal-dep-toggle) {\r\n  padding: 1.5rem;\r\n}\r\n\r\n.fiche-modal-dep-toggle {\r\n  margin-top: 0;\r\n  padding: 0.5rem 1.5rem 1rem;\r\n  background: none;\r\n  border: none;\r\n  color: #4f71be;\r\n  font-size: 1.1rem;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  padding: 0;\r\n  text-decoration: underline;\r\n  text-underline-offset: 2px;\r\n}\r\n\r\n.fiche-modal-collapse-toggle {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  width: 100%;\r\n  background: #595959;\r\n  border: none;\r\n  cursor: pointer;\r\n  padding: 1.25rem 1.5rem;\r\n  margin-bottom: 0;\r\n}\r\n\r\n.fiche-modal-collapse-toggle .fiche-modal-section-title {\r\n  padding: 0;\r\n  background: none;\r\n  color: #fff;\r\n}\r\n\r\n.fiche-modal-collapse-toggle:hover .fiche-modal-section-title {\r\n  color: #e5e7eb;\r\n}\r\n\r\n.fiche-modal-collapse-icon {\r\n  font-size: 1rem;\r\n  color: #9ca3af;\r\n  transition: transform 0.2s;\r\n  display: inline-block;\r\n}\r\n\r\n.fiche-modal-collapse-icon.expanded {\r\n  transform: rotate(180deg);\r\n}\r\n\r\n.fiche-modal-collapse-arrow {\r\n  width: 20px;\r\n  height: 20px;\r\n  flex-shrink: 0;\r\n  fill: #ffffff;\r\n}\r\n\r\n.fiche-modal-contact-name {\r\n  font-weight: 600;\r\n  font-size: 1.35rem;\r\n  color: #1f2937;\r\n}\r\n\r\n.fiche-modal-contact-detail {\r\n  color: #6b7280;\r\n}\r\n\r\n.fiche-modal-contact-detail a {\r\n  color: #4f71be;\r\n  text-decoration: none;\r\n}\r\n\r\n.fiche-modal-contact-detail a:hover {\r\n  text-decoration: underline;\r\n}\r\n\r\n.fiche-modal-footer {\r\n  display: flex;\r\n  justify-content: flex-end;\r\n  padding: 1.4rem 2rem;\r\n  border-top: 1px solid #e5e7eb;\r\n  background: #fafafa;\r\n  flex-shrink: 0;\r\n}\r\n\r\n/* ============================================================\r\n   Modal documents (annuaire)\r\n   ============================================================ */\r\n\r\n.annuaire-docs-modal {\r\n  background: white;\r\n  border-radius: 14px;\r\n  max-width: 680px;\r\n  width: 90%;\r\n  max-height: 88vh;\r\n  display: flex;\r\n  flex-direction: column;\r\n  overflow: hidden;\r\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.18);\r\n}\r\n\r\n.annuaire-docs-modal-header {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  padding: 1.6rem 2rem;\r\n  border-bottom: 1px solid #e5e7eb;\r\n  background: #fafafa;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.annuaire-docs-modal-title {\r\n  font-size: 1.5rem;\r\n  font-weight: 700;\r\n  color: #1f2937;\r\n  margin: 0;\r\n}\r\n\r\n.annuaire-docs-modal-body {\r\n  padding: 2rem;\r\n  overflow-y: auto;\r\n  flex: 1;\r\n}\r\n\r\n/* ══════════════════════════════════════════════════════════════\r\n   Onglet Acheteurs — toolbar, cartes, tableau\r\n   ══════════════════════════════════════════════════════════════ */\r\n\r\n.acheteurs-toolbar {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: 1rem;\r\n  margin-bottom: 1.5rem;\r\n}\r\n\r\n.acheteurs-filters {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: 0.75rem;\r\n  align-items: center;\r\n  flex: 1;\r\n}\r\n\r\n.acheteurs-filter-input,\r\n.acheteurs-filter-select {\r\n  height: 38px;\r\n  padding: 0 0.75rem;\r\n  border: 1px solid #d1d5db;\r\n  border-radius: 6px;\r\n  font-size: 0.875rem;\r\n  color: #374151;\r\n  background: #fff;\r\n  min-width: 180px;\r\n  max-width: 260px;\r\n}\r\n.acheteurs-filter-input:focus,\r\n.acheteurs-filter-select:focus {\r\n  outline: none;\r\n  border-color: #9ca3af;\r\n}\r\n\r\n.acheteurs-filter-clear {\r\n  height: 38px;\r\n  padding: 0 1rem;\r\n  border: 1px solid #d1d5db;\r\n  border-radius: 6px;\r\n  font-size: 0.85rem;\r\n  color: #6b7280;\r\n  background: #f9fafb;\r\n  cursor: pointer;\r\n}\r\n.acheteurs-filter-clear:hover {\r\n  background: #f3f4f6;\r\n  color: #374151;\r\n}\r\n\r\n.acheteurs-view-toggle {\r\n  display: flex;\r\n  gap: 0.25rem;\r\n  background: #f3f4f6;\r\n  border-radius: 8px;\r\n  padding: 3px;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.acheteurs-toggle-btn {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.4rem;\r\n  padding: 0.4rem 0.85rem;\r\n  border: none;\r\n  border-radius: 6px;\r\n  font-size: 0.85rem;\r\n  color: #6b7280;\r\n  background: transparent;\r\n  cursor: pointer;\r\n  transition:\r\n    background 0.15s,\r\n    color 0.15s;\r\n}\r\n.acheteurs-toggle-btn.active {\r\n  background: #fff;\r\n  color: #374151;\r\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\r\n}\r\n.acheteurs-toggle-btn:hover:not(.active) {\r\n  color: #374151;\r\n}\r\n\r\n/* ── Grille ─────────────────────────────────────────────────── */\r\n\r\n.acheteurs-cards-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));\r\n  gap: 1.25rem;\r\n}\r\n\r\n/* ── Carte acheteur ─────────────────────────────────────────── */\r\n\r\n.acheteur-card {\r\n  background: #fff;\r\n  border-radius: 12px;\r\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);\r\n  padding: 1.4rem 1.2rem 1.2rem;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  text-align: center;\r\n  cursor: pointer;\r\n  position: relative;\r\n  transition:\r\n    box-shadow 0.2s,\r\n    transform 0.2s;\r\n  gap: 0.5rem;\r\n}\r\n.acheteur-card:hover {\r\n  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.13);\r\n  transform: translateY(-2px);\r\n}\r\n\r\n/* badge rond en haut à droite */\r\n.acheteur-badge-dot {\r\n  position: absolute;\r\n  top: 0.7rem;\r\n  right: 0.7rem;\r\n  width: 22px;\r\n  height: 22px;\r\n  border-radius: 50%;\r\n  background: #e5e7eb;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n.acheteur-badge-dot::after {\r\n  content: \"\";\r\n  display: block;\r\n  width: 10px;\r\n  height: 10px;\r\n  border-radius: 50%;\r\n  background: #9ca3af;\r\n}\r\n.acheteur-badge-dot--orange {\r\n  background: #fff3e0;\r\n}\r\n.acheteur-badge-dot--orange::after {\r\n  background: #f97316;\r\n}\r\n\r\n/* avatar initiales */\r\n.acheteur-card-avatar {\r\n  width: 60px;\r\n  height: 60px;\r\n  border-radius: 50%;\r\n  background: #e5e7eb;\r\n  color: #9ca3af;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  font-size: 1.2rem;\r\n  font-weight: 700;\r\n  letter-spacing: 1px;\r\n  margin-top: 0.2rem;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.acheteur-card-body {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  gap: 0.25rem;\r\n  width: 100%;\r\n}\r\n\r\n.acheteur-card-nom {\r\n  font-weight: 700;\r\n  font-size: 0.88rem;\r\n  color: #1f2937;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  width: 100%;\r\n  margin: 0;\r\n}\r\n\r\n.acheteur-card-dept {\r\n  font-size: 0.78rem;\r\n  color: #6b7280;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  width: 100%;\r\n  margin: 0;\r\n}\r\n\r\n.acheteur-card-categorie {\r\n  display: inline-block;\r\n  margin-top: 0.15rem;\r\n  font-size: 0.73rem;\r\n  color: #6b7280;\r\n  background: #f3f4f6;\r\n  border-radius: 4px;\r\n  padding: 0.12rem 0.45rem;\r\n  max-width: 100%;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n}\r\n\r\n/* ── Skeleton acheteur ──────────────────────────────────────── */\r\n\r\n@keyframes ac-shimmer {\r\n  0% {\r\n    background-position: -200% 0;\r\n  }\r\n  100% {\r\n    background-position: 200% 0;\r\n  }\r\n}\r\n\r\n.acheteur-card-skeleton {\r\n  pointer-events: none;\r\n}\r\n\r\n.acheteur-card-skeleton .sk-badge-dot,\r\n.acheteur-card-skeleton .sk-avatar,\r\n.acheteur-card-skeleton .sk-ac {\r\n  background: linear-gradient(90deg, #e5e7eb 25%, #f3f4f6 50%, #e5e7eb 75%);\r\n  background-size: 200% 100%;\r\n  animation: ac-shimmer 1.4s ease-in-out infinite;\r\n}\r\n\r\n.acheteur-card-skeleton .sk-badge-dot {\r\n  border-radius: 50%;\r\n}\r\n.acheteur-card-skeleton .sk-badge-dot::after {\r\n  display: none;\r\n}\r\n\r\n.acheteur-card-skeleton .sk-avatar {\r\n  border-radius: 50%;\r\n  color: transparent;\r\n}\r\n\r\n.sk-ac {\r\n  display: block;\r\n  border-radius: 4px;\r\n}\r\n.sk-ac-nom {\r\n  height: 13px;\r\n  width: 75%;\r\n  margin: 0 auto;\r\n}\r\n.sk-ac-dept {\r\n  height: 11px;\r\n  width: 60%;\r\n  margin: 3px auto 0;\r\n}\r\n.sk-ac-cat {\r\n  height: 10px;\r\n  width: 45%;\r\n  margin: 4px auto 0;\r\n  border-radius: 4px;\r\n}\r\n\r\n/* ── Tableau acheteurs ──────────────────────────────────────── */\r\n\r\n.acheteurs-table-wrapper {\r\n  overflow-x: auto;\r\n  border-radius: 8px;\r\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.07);\r\n}\r\n\r\n.acheteurs-table {\r\n  width: 100%;\r\n  border-collapse: collapse;\r\n  background: #fff;\r\n  font-size: 0.9rem;\r\n}\r\n\r\n.acheteurs-table th {\r\n  background: #f3f4f6;\r\n  color: #595959;\r\n  font-weight: 600;\r\n  font-size: 0.8rem;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.05em;\r\n  padding: 0.75rem 1rem;\r\n  text-align: left;\r\n  border-bottom: 2px solid #e5e7eb;\r\n}\r\n\r\n.acheteurs-table td {\r\n  padding: 0.75rem 1rem;\r\n  color: #374151;\r\n  border-bottom: 1px solid #f3f4f6;\r\n  vertical-align: middle;\r\n}\r\n\r\n.acheteurs-table-row {\r\n  cursor: pointer;\r\n  transition: background 0.1s;\r\n}\r\n.acheteurs-table-row:hover {\r\n  background: #f9fafb;\r\n}\r\n.acheteurs-table-nom {\r\n  font-weight: 600;\r\n}\r\n\r\n.acheteurs-non-renseigne {\r\n  color: #9ca3af;\r\n  font-style: italic;\r\n}\r\n\r\n.acheteur-recent-badge {\r\n  display: inline-block;\r\n  padding: 0.15rem 0.6rem;\r\n  border-radius: 12px;\r\n  font-size: 0.78rem;\r\n  font-weight: 600;\r\n  background: #f3f4f6;\r\n  color: #9ca3af;\r\n}\r\n.acheteur-recent-badge--orange {\r\n  background: #fff3e0;\r\n  color: #f97316;\r\n}\r\n\r\n.acheteurs-empty {\r\n  color: #9ca3af;\r\n  font-style: italic;\r\n  padding: 2rem 0;\r\n  text-align: center;\r\n}\r\n\r\n/* ── Chip catégorie sous la ligne département ── */\r\n\r\n.prestataire-card-categorie {\r\n  display: inline-block;\r\n  margin-top: 0.25rem;\r\n  font-size: 1.2rem;\r\n  color: #374151;\r\n  background: #f3f4f6;\r\n  border-radius: 4px;\r\n  padding: 0.15rem 0.6rem;\r\n  max-width: 100%;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n  font-weight: 500;\r\n}\r\n\r\n/* Signup prompt pour non-connectés */\r\n.annuaire-signup-prompt {\r\n  position: relative;\r\n  background: #fff;\r\n  border-radius: 16px;\r\n  padding: 2.5rem 2rem 2rem;\r\n  max-width: 420px;\r\n  width: 90%;\r\n  text-align: center;\r\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.18);\r\n}\r\n\r\n.annuaire-signup-prompt .fiche-modal-close {\r\n  position: absolute;\r\n  top: 1rem;\r\n  right: 1rem;\r\n}\r\n\r\n.annuaire-signup-prompt-icon {\r\n  font-size: 2.5rem;\r\n  margin-bottom: 1rem;\r\n}\r\n\r\n.annuaire-signup-prompt-title {\r\n  font-size: 1.65rem;\r\n  font-weight: 700;\r\n  color: #1f2937;\r\n  margin-bottom: 0.85rem;\r\n}\r\n\r\n.annuaire-signup-prompt-text {\r\n  font-size: 1.2rem;\r\n  color: #6b7280;\r\n  line-height: 1.65;\r\n  margin-bottom: 1.75rem;\r\n}\r\n\r\n.annuaire-signup-prompt-actions {\r\n  display: flex;\r\n  gap: 1rem;\r\n  justify-content: center;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.annuaire-signup-prompt-btn {\r\n  padding: 0.7rem 1.6rem;\r\n  border-radius: 8px;\r\n  font-size: 1rem;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  border: none;\r\n  transition: opacity 0.15s;\r\n}\r\n\r\n.annuaire-signup-prompt-btn:hover {\r\n  opacity: 0.88;\r\n}\r\n\r\n.annuaire-signup-prompt-btn--primary {\r\n  background: #f97316;\r\n  color: #fff;\r\n}\r\n\r\n.annuaire-signup-prompt-btn--secondary {\r\n  background: #f3f4f6;\r\n  color: #374151;\r\n  border: 1px solid #e5e7eb;\r\n}\r\n\r\n/* Les cartes non-connectées sont cliquables */\r\n.prestataire-card--readonly:not([class*=\"suspendu\"]) {\r\n  cursor: pointer;\r\n}\r\n\r\n.prestataire-card--readonly:not([class*=\"suspendu\"]):hover {\r\n  box-shadow: 0 4px 16px rgba(249, 115, 22, 0.15);\r\n  transform: translateY(-2px);\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
